<template>
    <li class="payment-mode-item" :class="{active: active}">
        <div class="payment-mode-card">
            <div class="payment-mode-icon" @click="select(id)"></div>
            <div class="payment-mode-col">
                <div class="payment-mode-name" @click="select(id)">{{ title }}</div>
                <div class="payment-mode-extra" v-if="active"><slot /></div>
            </div>
        </div>
    </li>
</template>
<script>
export default {
    name: 'PaymentModeItem',
    props: {
        id: {
            type: String,
            default: '',
        },
        title: {
            type: String,
            default: '',
        },
    },
    computed: {
        active() {
            return this.$store.getters.paymentMode == this.id;
        }
    },
    methods: {
        select() {
            this.$store.dispatch('setPaymentMode', this.id);
        }
    },
};
</script>
<style lang="scss">
.payment-mode {
    &-item {
        margin-bottom: 8px;
        position: relative;
        &:last-child{
            margin-bottom: 0px;
        }
    }
    &-item.active &-icon {
        border: 2px solid #161616;
        position: relative;
        &:before{
            content: '';
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%,-50%);
            width: 12px;
            height: 12px;
            -webkit-border-radius: 50%;
            -moz-border-radius: 50%;
            border-radius: 50%;
        }
    }
    &-card {
        display: flex;
        align-items: flex-start;
        border: 2px solid transparent;
        padding: 6px 15px 6px 10px;
        position: relative;
    }
    &-icon {
        cursor: pointer;
        flex-basis: 24px;
        flex-grow: 0;
        flex-shrink: 0;
        height: 24px;
        border: 1px solid;
        border-radius: 50%;
        margin-right: 12px;
        transition: all 0.3s;
        &:hover{
            border: 2px solid #161616;
        }
    }
    &-name {
      cursor: pointer;
      font-weight: bold;
      font-size: 15px;
      line-height: 22px;
      margin-bottom: 1px;
    }
    &-extra {
        margin-top: 20px;
        margin-bottom: 20px;
        font-size: 15px;
        line-height: 22px;
        padding-right: 30px;
    }
}
</style>
